module.exports = "<label class=\"input\"\n       *ngFor=\"let row of question?.rows\"\n       [attr.for]=\"row._id\"\n       [class.disabled]=\"row.type !== 'na' && naAnswered\">\n  <input type=\"{{ question.qType }}\"\n         [id]=\"row._id\"\n         (click)=\"setValue(row)\"\n         [checked]=\"row.value\"\n         [attr.name]=\"question._id\">\n  {{ row.text }}\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/checkbox-or-radio/checkbox-or-radio.component.html
// module id = 283
// module chunks = 1